import  openForOffer from '../../../../assets/img/openToOffersNew.svg';
import  notAvailable from '../../../../assets/img/not_available_for_work_new.svg';
import  readyForInterview from '../../../../assets/img/available_for_work_new.svg';
import  readyForInterviewReplacement from '../../../../assets/img/available_for_work_warning_new.svg';
import { NotAvailableIcon, OpenToOffersIcon, AvailableIcon } from '../../../components/common/CustomIcon';


export const AvailabilityDetails = [
  {
    label: 'Ready to Interview',
    value: 'ready-to-interview',
    details: 'I am actively looking for a new remote job. Mark me available to interview for the next 30 days.',
    icon: readyForInterview,
    iconText: 'Available for Jobs',
    replacementIcon: readyForInterviewReplacement,
    svgIcon: AvailableIcon,
    user_selectable: true
  },
  {
    label: 'Open to Offers',
    value: 'open-to-offers',
    details: 'I am not actively looking for a new remote job, but I am available to hear about new job opportunities for the next 30 days.',
    icon: openForOffer,
    svgIcon: OpenToOffersIcon,
    user_selectable: true
  },
  {
    label: 'Unavailable for Jobs',
    value: 'not-looking-for-job',
    details: 'I am not looking for a new remote job at the moment.',
    icon: notAvailable,
    svgIcon: NotAvailableIcon,
    user_selectable: true
  },
  {
    label: 'Unavailable for Jobs',
    value: 'unknown',
    details: 'Unknown.',
    icon: notAvailable,
    svgIcon: NotAvailableIcon,
    user_selectable: false
  }
];

export const notAllowedStatus = ['a/v matchability issues', 'resume matchability issues', 'advanced notice too long', 'need quick rematch', 'visa/legal issues'];
